/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import IntegrationsfreshpaintFreshpaintIntegration from './IntegrationsfreshpaintFreshpaintIntegration';

/**
 * The IntegrationsSegmentBody model module.
 * @module model/IntegrationsSegmentBody
 * @version v0.3
 */
export default class IntegrationsSegmentBody {
  /**
   * Constructs a new <code>IntegrationsSegmentBody</code>.
   * @alias module:model/IntegrationsSegmentBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>IntegrationsSegmentBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/IntegrationsSegmentBody} obj Optional instance to populate.
   * @return {module:model/IntegrationsSegmentBody} The populated <code>IntegrationsSegmentBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new IntegrationsSegmentBody();
      if (data.hasOwnProperty('segment_integration'))
        obj.segmentIntegration = IntegrationsfreshpaintFreshpaintIntegration.constructFromObject(data['segment_integration']);
    }
    return obj;
  }
}

/**
 * @member {module:model/IntegrationsfreshpaintFreshpaintIntegration} segmentIntegration
 */
IntegrationsSegmentBody.prototype.segmentIntegration = undefined;

